import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgreementTerm from '@/models/AgreementTerm.js'

export const useAgreementTermStore = defineStore('agreementTermStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agreement_terms'), {
    className: AgreementTerm.modelName.name,
    paramKey: AgreementTerm.modelName.paramKey
  })

  function findByUuidAndType(uuid, type) {
    return syncableModel.collection.value.find((e) => e.customer_uuid === uuid && e.name === type)
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    findByUuidAndType,
    $reset
  }

}, {
  persist: true
})
